import { createContext, useContext } from "react";

const EditPanelContext = createContext(null);

export const EditPanelProvider = ({ value, children }) => (
  <EditPanelContext.Provider value={value}>{children}</EditPanelContext.Provider>
);

export const useEditPanelContext = () => {
  const ctx = useContext(EditPanelContext);
  if (!ctx) throw new Error("useEditPanelContext must be used inside EditPanelProvider");
  return ctx;
};